import { DELETE_CODE } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_CODE.LOAD:
      return {
        ...state,
        loading: true
      };
    case DELETE_CODE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case DELETE_CODE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
